import http from '@utils/http'
/*
* 上传图片并绑卡
**/
export function uploadAndBind(data): Promise<any> {
    return http.post('/login/uploadAndBind', data || {})
}
/*
* 获取用户的地址信息
**/
export function currentBillInfo(data): Promise<any> {
    return http.post('/bill/currentBillInfo', data || {})
}
/*
* 更改昵称
**/
export function updateCustomerNickName(data): Promise<any> {
    return http.post('/login/updateCustomerNickName', data || {})
}
/*
* 新增地址信息
**/
export function insertBillInfo(data): Promise<any> {
    return http.post('/bill/insert', data || {})
}
/*
* 生成支付表单
**/
export function payvalidation(data): Promise<any> {
    return http.post('/cybersource/payvalidation', data || {})
}

export function getCheckoutId(data): Promise<any> {
    return http.post('/aciPay/checkout', data || {})
}
/*
* aci判断是否可以选择旧卡
**/
export function aciCheckBillInfo(data): Promise<any> {
    return http.post('/aciPay/checkBillInfo', data || {})
}

/*
* 查询支付结果
**/
export function getPaymentStatus(data): Promise<any> {
    return http.post('/aciPay/paymentStatus', data || {})
}
/*
* 支持多次查询支付结果
**/
export function getPaymentReport(data): Promise<any> {
    return http.post('aciPay/paymentReport', data || {})
}

export function queryConfigValue(data): Promise<any> {
    return http.post('/podpage/queryConfigValue', data || {})
}

/*
* 生成支付表单
**/
export function doCyberSourcePay(url, data): Promise<any> {
    return http.post(url, data || {})
}
/*
* 判断支付类型
**/
export function isCybersource(data): Promise<any> {
    return http.post('/aciPay/isCybersource', data || {})
}
